import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';
import { MapGeofenceIcon } from '../../../common/icons';

import './MapGeofence.css';

@inject('translationsStore')
@observer
export default class MapGeofence extends Component {
  render() {
    const { translationsStore } = this.props;

    if (!(this.props.hasOwnProperty('visible') && !this.props.visible)) {
      return (
        <div className={`MapGeofence ${this.props.className || ''}`} style={this.props.style}>
          { !this.props.triggerRender ?
              <div className="MapGeofenceTrigger" style={{padding: '0 10px'}} onClick={isFunction(this.props.onToggleCollapse) ? this.props.onToggleCollapse : undefined}>
                <MapGeofenceIcon width={50} height={50} />
                <div style={{marginTop: 0}}>{translationsStore.translate('mapGeofence.trigger.labelArea')}</div>
              </div>
            :
              (this.props.triggerRender)
          }
          { !this.props.collapsed &&
            (this.props.children)
          }
        </div>
      );
    } else {
      return <Fragment />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapGeofence/MapGeofence.js